/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';


export interface HonorRollRequest {

    id?: string;

    /**
     * First name
     */
    first_name?: string;

    /**
     * Last name
     */
    last_name?: string;

    /**
     * Number of sponsorships purchased
     */
    purchased_quantity?: number;

    /**
     * The price of the sponsorship package
     */
    dollar_price?: string;

    /**
     * The name of the sponsorship package
     */
    package_name?: string;

    /**
     * Date the sponsorship was purchased
     */
    purchased_at?: string;

}

@Model('HonorRoll')
export class ApiHonorRoll extends BaseModel implements HonorRollRequest {

    
    
    id: string;

    /**
     * First name
     */
    
    
    first_name: string;

    /**
     * Last name
     */
    
    
    last_name: string;

    /**
     * Number of sponsorships purchased
     */
    
    
    purchased_quantity: number;

    /**
     * The price of the sponsorship package
     */
    
    
    dollar_price: string;

    /**
     * The name of the sponsorship package
     */
    
    
    package_name: string;

    /**
     * Date the sponsorship was purchased
     */
    
    
    purchased_at: string;

}
